import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import classes from "./ProductDetail.module.css";
import { FaInfoCircle, FaMale } from "react-icons/fa";
import { FaFemale } from "react-icons/fa";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { FiCopy, FiPlusCircle } from "react-icons/fi";
import ImageUploadModal from "../ImageUploadModal/ImageUploadModal";
import toast from "react-hot-toast";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

const ProductDetail = () => {
  const { addToast } = useToasts();
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [models, setModels] = useState([]);
  const [modelsData, setModelsData] = useState([]);
  const [variantJson, setVariantJson] = useState([]);
  const [selectedSide, setSelectedSide] = useState("Left");
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const [tooltipData, setTooltipData] = useState(null);
  const [isImageUploadModalOpen, setIsImageUploadModalOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filters, setFilters] = useState({
    bodyType: "",
    company: "",
    gender: "",
    status: "",
  });

  const [filterOptions, setFilterOptions] = useState({
    genderOptions: [],
    bodyTypeOptions: [],
    companyOptions: [],
    statusOptions: [],
  });

  const [imgwidth, setImgWidth] = useState("");
  const [toggleVisibility, setToggleVisibility] = useState({});
  const dispatch = useDispatch();

  const fetchProductDetails = async () => {
    try {
      const url = `${endpoint.GET_PRODUCT_BY_ID}${id}`;
      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        const productData = response.data.data?.product;
        setProduct(productData);
        const variantData = response.data.data.variantJson;
        setVariantJson(variantData);
        const filtersData = response.data.data.dropdownData;
        setFilterOptions({
          genderOptions: filtersData.genderDropdown,
          bodyTypeOptions: filtersData.bodyTypeDropdown,
          companyOptions: filtersData.companyDropdown,
          statusOptions: filtersData.statusDropdown,
        });
        setFilters({
          bodyType: productData?.iBodyTypeId,
          company: productData?.iStoreId,
          gender: productData?.iGenderId,
        });
        const images = response.data.data?.productImages || [];
        setProductImages(images);
        setSelectedImage(images.length > 0 ? images[0].iProductGalleryId : "");
        setModels(response.data.data?.models);
      }
    } catch (error) {
      console.log("Error fetching product details", error);
    }
  };

  useEffect(() => {
    fetchProductDetails();
  }, [id]);

  const handleFilterChange = async (e) => {
    const { name, value } = e.target;

    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));

    try {
      if (name === "status" && value !== "Select Status") {
        const response = await apiHandler({
          url:
            endpoint.UPDATE_STATUS +
            productImages.find(
              (image) => image.iProductGalleryId === selectedImage
            )?.iProductGalleryId,
          method: "PATCH",
          authToken: authData,
          data: {
            iStatusId: value,
          },
          storeId,
          dispatch,
        });
        if (response.data.status === "success") {
          addToast(response.data.message, {
            appearance: "success",
          });
          fetchProductDetails();
        } else {
          console.error("Failed to update status", response.data.message);
        }
      } else if (name !== "status") {
        const updatePayload = {};
        if (name === "gender") updatePayload.iGenderId = value;
        if (name === "bodyType") updatePayload.iBodyTypeId = value;
        if (name === "company") updatePayload.iStoreId = value;

        const response = await apiHandler({
          url: endpoint.UPDATE_PRODUCT + product.iProductId,
          method: "PUT",
          authToken: authData,
          data: updatePayload,
          storeId,
          dispatch,
        });

        if (response.data.status === "success") {
          addToast(response.data.message, {
            appearance: "success",
          });
          fetchProductDetails();
        }
      }
      if (name === "bodyType") {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error("Error updating product", error);
    }
  };

  const calculatePosition = (
    coOrdinates,
    product,
    newwidth,
    newheight,
    prodHeight,
    prodWidth
  ) => {
    if (product.iBodyTypeId === 3) {
      const positions = [];
      const fingerNames = Object.keys(coOrdinates.coordinates).filter(
        (key) => key !== "hand" && key !== "sUUID" && key != "sImageURL"
      );
      console.log(coOrdinates, "coOrdinates");

      fingerNames.forEach((finger) => {
        const fingerData = coOrdinates.coordinates[finger][0];

        if (fingerData) {
          let [leftX, leftY] = fingerData.left;

          leftX = leftX * newwidth;
          leftY = leftY * newheight;

          let [rightX, rightY] = fingerData.right;
          rightX = rightX * newwidth;
          rightY = rightY * newheight;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          const length = Math.sqrt(
            Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
          );
          const aspectRatio = prodHeight / prodWidth;
          const angle =
            (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

          positions.push({
            left: centerX,
            top: centerY,
            rotationAngle: angle,
            height: length * aspectRatio,
            width: length + length * 0.1,
            leftX,
            leftY,
            rightX,
            rightY,
            centerX,
            centerY,
          });
        }
      });

      return positions;
    } else if (product.iBodyTypeId === 1) {
      if (coOrdinates) {
        let coOrdinates1 = coOrdinates.wrist
          ? coOrdinates.wrist.coordinates[0]
          : coOrdinates.wrist;
        const handCooridntaes = coOrdinates.hand;
        let hand = coOrdinates.wrist
          ? coOrdinates.wrist.hand
          : coOrdinates.hand;
        let [leftX, leftY] = coOrdinates1.left;
        leftX = leftX * newwidth;
        leftY = leftY * newheight;
        const aspectRatio = prodHeight / prodWidth;
        let [rightX, rightY] = coOrdinates1.right;
        rightX = rightX * newwidth;
        rightY = rightY * newheight;

        let centerX = (leftX + rightX) / 2;
        let centerY = (leftY + rightY) / 2;

        const length = Math.sqrt(
          Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
        );

        const angle =
          hand === "right"
            ? Math.abs(
                (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI
              )
            : Math.abs(
                (Math.atan2(leftY - rightY, leftX - rightX) * 180) / Math.PI
              );
        return {
          left: centerX,
          top: centerY,
          rotationAngle: angle,
          height: length * aspectRatio,
          width: length + length * 0.1,
          leftX,
          leftY,
          rightX,
          rightY,
          centerX,
          centerY,
        };
      }
    } else if (product.iBodyTypeId === 4) {
      let neckCoordinates = coOrdinates?.neck_coordinates?.neck_wide
        ? coOrdinates?.neck_coordinates?.neck_wide
        : coOrdinates?.neck_mask_wide;
      let [leftX, leftY] = neckCoordinates.left_point;
      leftX = leftX * newwidth;
      leftY = leftY * newheight;

      let [rightX, rightY] = neckCoordinates.right_point;
      rightX = rightX * newwidth;
      rightY = rightY * newheight;

      let centerX = (leftX + rightX) / 2;
      let centerY = (leftY + rightY) / 2;

      const length = Math.sqrt(
        Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
      );

      let angle = (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

      if (Math.abs(angle) < 5) {
        angle = 0;
      }

      return {
        left: centerX - length / 2 - length * 0.1,
        top: centerY - length / 2 - length * 0.1,
        rotationAngle: angle,
        height: length + length * 0.2,
        width: length + length * 0.2,
        leftX,
        leftY,
        rightX,
        rightY,
        centerX,
        centerY,
      };
    } else if (product.iBodyTypeId === 2) {
      let earCoordinates = coOrdinates?.ear_coordinates;
      let positions = [];

      earCoordinates.forEach((earCoord) => {
        if (earCoord) {
          const [earX, earY] = earCoord;
          const x = earX * newwidth;
          const y = earY * newheight;
          let zoomfactor = coOrdinates.zoom_factor;
          const aspectRatio = product?.dProductHeight / product?.dProductWidth;
          const productImageHeight = product?.dProductHeight * zoomfactor;

          const productImageWidth =
            (product?.dProductHeight * zoomfactor) / aspectRatio;
          positions.push({
            left: x,
            top: y,
            height:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageHeight
                : 60,
            width:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageWidth
                : 60,
            leftX: x,
            leftY: y,
          });
        }
      });

      return positions;
    } else {
      console.error("Finger data not found for the current finger.");
    }
  };

  const handleToggleChange = (modelId) => {
    setToggleVisibility((prevToggleVisibility) => ({
      ...prevToggleVisibility,
      [modelId]: !prevToggleVisibility[modelId],
    }));
  };

  useEffect(() => {
    if (selectedImage) {
      setFilters({
        status:
          productImages.find(
            (image) => image.iProductGalleryId === selectedImage
          )?.iStatusId || "Select Status",

        bodyType: filters?.bodyType,
        company: filters?.company,
        gender: filters?.gender,
      });
    }
  }, [selectedImage, productImages]);

  useEffect(() => {
    const loadAllProductModelImages = async () => {
      if (!productImages?.length || !models?.length) return;

      const allResults = await Promise.all(
        productImages.map(async (prod) => {
          const productImageDimensions = await new Promise((resolve) => {
            const img = new Image();
            img.src = prod.sURL;

            img.onload = () => {
              resolve({ width: img.naturalWidth, height: img.naturalHeight });
            };

            img.onerror = () => resolve({ width: 0, height: 0 });
          });

          const loadImages = await Promise.all(
            models.map((model) => {
              return new Promise((resolve) => {
                const coordinates = JSON.parse(model.sCoordinate || "{}");

                if (
                  (product.iBodyTypeId === 1 || product.iBodyTypeId === 3) &&
                  model?.sTag?.toLowerCase() !== selectedSide?.toLowerCase()
                ) {
                  return resolve(null);
                }

                const img = new Image();
                img.src = model.sURL;

                img.onload = () => {
                  const height = img.height;
                  const width = img.width;
                  const newWidth = (500 * width) / height;

                  setImgWidth(newWidth);

                  const position = coordinates
                    ? calculatePosition(
                        coordinates,
                        product,
                        newWidth,
                        500,
                        productImageDimensions.height,
                        productImageDimensions.width
                      )
                    : null;

                  resolve({ ...model, productId: product.id, position });
                };

                img.onerror = () => resolve(null);
              });
            })
          );

          return loadImages.filter((m) => m !== null);
        })
      );

      // Flatten the results and set once
      const flattened = allResults.flat();
      const uniqueByGalleryId = Object.values(
        flattened.reduce((acc, item) => {
          acc[item.iGalleryId] = item;
          return acc;
        }, {})
      );

      setModelsData(uniqueByGalleryId);
    };

    loadAllProductModelImages();
  }, [models, product, selectedSide]);

  const handleSideChange = (e) => {
    setSelectedSide(e.target.value);
  };

  const renderDot = (top, left, color) => (
    <div
      style={{
        position: "absolute",
        backgroundColor: color,
        height: "5px",
        width: "5px",
        borderRadius: "50%",
        top: `${top}px`,
        left: `${left}px`,
        zIndex: 2,
      }}
    ></div>
  );

  const renderPositions = (model, positions, bodyType) => {
    if (bodyType === 2) {
      return positions.map((position) =>
        renderDot(position.leftY, position.leftX, "black")
      );
    }
    if (bodyType === 3) {
      return positions.map((position) => (
        <>
          {renderDot(position.leftY, position.leftX, "orange")}
          {renderDot(position.rightY, position.rightX, "green")}
          {renderDot(position.centerY, position.centerX, "tomato")}
        </>
      ));
    }
    return (
      <>
        {renderDot(model.position.leftY, model.position.leftX, "orange")}
        {renderDot(model.position.rightY, model.position.rightX, "green")}
        {renderDot(model.position.centerY, model.position.centerX, "tomato")}
      </>
    );
  };

  const handleMouseEnter = (product) => {
    setTooltipData(product);
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const handleImageUploadModalToggle = () => {
    setIsImageUploadModalOpen(!isImageUploadModalOpen);
  };

  const handleImageUploadSuccess = () => {
    fetchProductDetails();
  };

  const deleteImage = async () => {
    try {
      const response = await apiHandler({
        url: `${endpoint.DELETE_IMAGE}/${selectedImage}`,
        authToken: authData,
        method: "DELETE",
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        addToast(response.data.message, {
          appearance: "success",
        });
        fetchProductDetails();
      } else {
        addToast(response.data.message, {
          appearance: "failure",
        });
      }
    } catch (error) {
      console.log("Error deleting product");
    }
  };

  return (
    <div className="min-h-screen">
      <div className={classes.topheader}>
        <div className="flex justify-between align-items-center">
          <h1 className={`p-1 ${classes.titlename}`}>Products</h1>
          <button
            className={`flex items-center p-2 px-3 text-white rounded justify-center`}
            style={{ backgroundColor: "#646af5" }}
            onClick={() => navigate("/productsandbox")}
          >
            <MdOutlineKeyboardBackspace /> &nbsp; Go Back
          </button>
        </div>
      </div>

      <div className={classes.middle_main_container}>
        {product && (
          <div
            className={`d-lg-flex d-sm-flex gap-5 ${classes.productdetailFirst}`}
          >
            <div className={classes.productleftsection}>
              <div className={classes.productslidersection}>
                <img
                  src={
                    productImages.find(
                      (image) => image.iProductGalleryId === selectedImage
                    )?.sURL || "Product Image"
                  }
                  alt={
                    productImages.find(
                      (image) => image.iProductGalleryId === selectedImage
                    )?.sTag || "Product Image"
                  }
                  className=""
                />
                <p className="mt-2 text-center text-gray-700 font-semibold">
                  {productImages.find(
                    (image) => image.iProductGalleryId === selectedImage
                  )?.sTag || "Selected Image"}
                </p>
              </div>

              <div className={classes.productsliderthumbnails}>
                <div
                  className={`d-flex align-items-center justify-content-center gap-5 ${classes.productsliderthumbnailsImg}`}
                >
                  {productImages.map((image) => (
                    <div
                      key={image.iProductGalleryId}
                      style={{
                        height: "100px",
                        width: "100px",
                        padding: "5px",
                      }}
                      className={`flex items-center justify-center border rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-200 ${
                        selectedImage === image.iProductGalleryId
                          ? "!border-blue-500 border-2 shadow-lg"
                          : "!border-gray-300"
                      }`}
                      onClick={() => setSelectedImage(image.iProductGalleryId)}
                    >
                      <img
                        src={image.sURL}
                        alt={image.sTag}
                        className="h-full w-full object-contain rounded-lg"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={classes.productrightsection}>
              <h2 className="text-2xl font-semibold">{product.sProductName}</h2>
              {productImages.length > 0 && (
                <div
                  className={`flex items-center justify-end ${classes.selectproductColor}`}
                >
                  <button
                    className={`flex items-center p-2 px-3 text-white rounded justify-center`}
                    style={{ backgroundColor: "#dc3545" }}
                    onClick={deleteImage}
                  >
                    Delete Image
                  </button>
                </div>
              )}

              <div className={classes.selectProductColor}>
                <strong>Select Status</strong>
                <ul>
                  {filterOptions.statusOptions?.map((option, idx) => {
                    const isActive = filters.status === option.iStatusId;
                    return (
                      <li
                        className={
                          isActive
                            ? `${classes.item} ${classes.active}`
                            : classes.item
                        }
                        key={idx}
                        onClick={() =>
                          handleFilterChange({
                            target: { name: "status", value: option.iStatusId },
                          })
                        }
                      >
                        <span
                          className={classes.colorDot}
                          style={{
                            background: option.sColor,
                            borderColor: option.sColor,
                          }}
                        ></span>
                        <span className={classes.statusText}>
                          {option.sName}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className={classes.selectproductGender}>
                <strong> Gender</strong>
                <ul>
                  {filterOptions.genderOptions.map((option, idx) => (
                    <li
                      className={
                        filters.gender === option.iGenderId
                          ? classes.active
                          : ""
                      }
                      key={idx}
                      // onClick={() =>
                      //   handleFilterChange({
                      //     target: { name: "gender", value: option.iGenderId },
                      //   })
                      // }
                    >
                      {option.sName === "Male" ? <FaMale /> : <FaFemale />}
                      {option.sName}
                    </li>
                  ))}
                </ul>
              </div>

              {/* <div className={classes.selectbodycompany}>
                <div>
                  <strong>Select Body Type</strong>
                  <select
                    name="bodyType"
                    value={filters.bodyType}
                    onChange={handleFilterChange}
                    className=""
                  >
                    <option>Select Body Type</option>
                    {filterOptions.bodyTypeOptions.map((option) => (
                      <option
                        key={option.iBodyTypeId}
                        value={option.iBodyTypeId}
                      >
                        {option.sName}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
            </div>
          </div>
        )}
        {productImages.length > 0 && (
          <>
            {modelsData.length ? (
              <div className="bg-white p-6 rounded-lg shadow-lg mb-6 mt-10 h-[700px]">
                <div className="flex items-center justify-between mb-4">
                  <div className={classes.renderedText}>
                    Rendered Model Images
                  </div>
                  {(product.iBodyTypeId === 1 || product.iBodyTypeId === 3) && (
                    <select
                      value={selectedSide}
                      onChange={handleSideChange}
                      className="px-4 py-2 border rounded-md bg-white"
                    >
                      <option value="Left">Left</option>
                      <option value="Right">Right</option>
                    </select>
                  )}
                </div>

                <div className="overflow-x-auto flex space-x-4 h-full ">
                  {modelsData.map((model, modalIndex) => (
                    <div
                      key={modalIndex}
                      className={` flex-shrink-0 ${classes.renderedmodelImages}`}
                    >
                      <div
                        style={{ padding: "15px" }}
                        className="flex relative items-center justify-center bg bg-[#f4f7fb] shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                      >
                        <div className="bg-white rounded-xl p-[10px]">
                          <div
                            className="bg-gray-300 flex-shrink-0 "
                            style={{
                              position: "relative",
                              width: imgwidth,
                              height: "500px",
                              // height: "500px",
                            }}
                          >
                            <TransformWrapper
                              minScale={1}
                              maxScale={2}
                              disablePadding
                              centerZoomedOut
                              smooth
                              doubleClick={{ disabled: true }}
                            >
                              {/* <ZoomControls /> */}
                              <TransformComponent>
                                <img
                                  src={model.sURL}
                                  alt={`Model ${modalIndex}`}
                                  className="h-full w-full"
                                />{" "}
                                <div className="absolute top-2 right-2  rounded-full p-2">
                                  <div className="relative flex items-center">
                                    <input
                                      type="checkbox"
                                      id={`status-switch-${model.iGalleryId}`}
                                      checked={
                                        toggleVisibility[model.iGalleryId] ||
                                        false
                                      }
                                      onChange={() =>
                                        handleToggleChange(model.iGalleryId)
                                      }
                                      className="sr-only"
                                    />
                                    <div
                                      className={`w-10 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                                        toggleVisibility[model.iGalleryId]
                                          ? "bg-green-500"
                                          : "bg-gray-400"
                                      }`}
                                      onClick={() =>
                                        handleToggleChange(model.iGalleryId)
                                      }
                                    >
                                      <div
                                        className={`w-4 h-4 bg-white rounded-full shadow-md transform ${
                                          toggleVisibility[model.iGalleryId]
                                            ? "translate-x-4"
                                            : "translate-x-0"
                                        }`}
                                      />
                                    </div>
                                  </div>
                                </div>
                                {model?.position ? (
                                  <>
                                    {!toggleVisibility[model.iGalleryId] ? (
                                      <>
                                        {product.iBodyTypeId === 2 ? (
                                          <>
                                            {model?.position?.map(
                                              (position, index) => (
                                                <img
                                                  key={index}
                                                  src={
                                                    productImages.find(
                                                      (image) =>
                                                        image.iProductGalleryId ===
                                                        selectedImage
                                                    )?.sURL || "Product Image"
                                                  }
                                                  style={{
                                                    position: "absolute",
                                                    top: `${position.top}px`,
                                                    left: `${position.left}px`,
                                                    width: `${position.width}px`,
                                                    height: `${position.height}px`,
                                                    transform: `translateX(-50%)`,
                                                  }}
                                                />
                                              )
                                            )}
                                          </>
                                        ) : product.iBodyTypeId === 3 ? (
                                          <>
                                            {model?.position?.map(
                                              (position, index) => (
                                                <img
                                                  key={index}
                                                  src={
                                                    productImages.find(
                                                      (image) =>
                                                        image.iProductGalleryId ===
                                                        selectedImage
                                                    )?.sURL || "Product Image"
                                                  }
                                                  style={{
                                                    position: "absolute",
                                                    top: `${position.top}px`,
                                                    left: `${position.left}px`,
                                                    width: `${position.width}px`,
                                                    height: `${position.height}px`,
                                                    transform: `translate(-50%, -50%) rotate(${position.rotationAngle}deg)`,
                                                  }}
                                                />
                                              )
                                            )}
                                          </>
                                        ) : (
                                          <img
                                            src={
                                              productImages.find(
                                                (image) =>
                                                  image.iProductGalleryId ===
                                                  selectedImage
                                              )?.sURL || "Product Image"
                                            }
                                            style={{
                                              position: "absolute",
                                              top: `${model?.position.top}px`,
                                              left: `${model?.position.left}px`,
                                              width: `${model?.position.width}px`,
                                              height: `${model?.position.height}px`,
                                              transform: `  ${
                                                product.iBodyTypeId === 4
                                                  ? "translateY(50%)"
                                                  : product.iBodyTypeId === 1
                                                  ? "translate(-50%, -50%)"
                                                  : ""
                                              } rotate(${
                                                model?.position.rotationAngle
                                              }deg)`,
                                            }}
                                          />
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {renderPositions(
                                          model,
                                          model?.position || [],
                                          product.iBodyTypeId
                                        )}
                                      </>
                                    )}
                                  </>
                                ) : null}
                              </TransformComponent>
                            </TransformWrapper>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
          </>
        )}

        {variantJson.length ? (
          <div className="bg-white p-6 rounded-lg shadow-lg mb-6 mt-10">
            <div className="flex items-center justify-between mb-4">
              <div className={classes.renderedText}>Variant Images</div>
            </div>
            <div className="overflow-x-auto flex space-x-4  h-full">
              {variantJson.length > 0 ? (
                <>
                  {variantJson.map((product, idx) => {
                    return (
                      <div
                        className={`bg-gray-300 flex-shrink-0 ${classes.renderedVariantImages}`}
                        key={idx}
                      >
                        <div
                          className={`${classes.productsimg} mx-auto relative`}
                        >
                          {/* <Link to={`/product/${product?.iProductId}`}>
                           
                          </Link> */}

                          {!product.aImageJson ? (
                            <>
                              {
                                <div
                                  onClick={() => {
                                    handleImageUploadModalToggle(),
                                      setSelectedProduct(product);
                                  }}
                                  className="absolute inset-0 flex items-center justify-center cursor-pointer"
                                >
                                  <FiPlusCircle
                                    size={50}
                                    className="text-blue-500"
                                  />
                                </div>
                              }
                            </>
                          ) : (
                            <Link
                              to={`/variant/${product?.iVariantId}`}
                              state={{ iProductId: id }}
                            >
                              <img
                                src={JSON.parse(product.aImageJson)[0].sURL}
                                alt="Thumbnail"
                                className="object-contain"
                              />
                            </Link>
                          )}
                        </div>

                        <FaInfoCircle
                          className="absolute top-2 right-2 text-blue-500"
                          size={20}
                          onMouseEnter={() => handleMouseEnter(product)}
                          onMouseLeave={handleMouseLeave}
                        />
                        {showTooltip &&
                          tooltipData.iVariantId === product.iVariantId && (
                            <div
                              className={classes.tooltip}
                              style={{
                                position: "absolute",
                                top: "30px",
                                left: "10px",
                                right: "10px",
                              }}
                            >
                              <div
                                className={`bg-white p-2 rounded ${classes.smallBoxdetails}`}
                              >
                                <p>
                                  <strong>Name:</strong> {tooltipData.sTitle}
                                </p>

                                <p>
                                  <strong>Gender:</strong>{" "}
                                  {tooltipData.sGenderName}
                                </p>

                                <p>
                                  <strong>sku:</strong> {tooltipData.sSKU}
                                </p>
                              </div>
                            </div>
                          )}

                        <div className={classes.photolistcount}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M9.99999 2.66666H10.6667C10.8435 2.66666 11.013 2.73689 11.1381 2.86192C11.2631 2.98694 11.3333 3.15651 11.3333 3.33332V5.66666M13.3333 3.99999C13.5093 4.07466 13.68 4.14466 13.8453 4.20999C14.0081 4.27905 14.1367 4.40992 14.203 4.57382C14.2692 4.73772 14.2677 4.92123 14.1987 5.08399L12.6667 8.66666M2.40265 4.79799L7.16132 2.72532C7.23984 2.69167 7.32431 2.67407 7.40974 2.67358C7.49517 2.67308 7.57984 2.6897 7.65875 2.72244C7.73765 2.75518 7.80921 2.80339 7.86919 2.86423C7.92917 2.92506 7.97636 2.99729 8.00799 3.07666L11.2907 11.0113C11.3589 11.1722 11.3612 11.3535 11.2971 11.5161C11.233 11.6787 11.1077 11.8096 10.948 11.8807L6.18999 13.9533C6.11143 13.9871 6.0269 14.0048 5.9414 14.0053C5.85589 14.0059 5.77114 13.9893 5.69216 13.9565C5.61317 13.9238 5.54155 13.8755 5.48152 13.8146C5.42149 13.7537 5.37427 13.6814 5.34265 13.602L2.05999 5.66666C1.99175 5.50576 1.98943 5.3245 2.05352 5.16191C2.11761 4.99931 2.24299 4.86906 2.40265 4.79799Z"
                              stroke="#98A4AE"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span>
                            {product.aImageJson
                              ? JSON.parse(product.aImageJson).length
                              : 0}
                          </span>{" "}
                          <div className={classes.productName}>
                            <div className="flex items-center gap-2">
                              <span className="font-semibold text-gray-800">
                                {product.sTitle}
                              </span>
                              {product.sSKU && (
                                <button
                                  onClick={() => {
                                    navigator.clipboard.writeText(product.sSKU);
                                    toast.success("SKU Copied to clipboard");
                                  }}
                                  className="text-xs text-blue-500 hover:underline"
                                  title="Copy SKU"
                                >
                                  <FiCopy size={16} />
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div className="text-center col-span-12">
                  No Products Found!
                </div>
              )}
            </div>
          </div>
        ) : null}
      </div>
      <ImageUploadModal
        isOpen={isImageUploadModalOpen}
        onClose={handleImageUploadModalToggle}
        onUploadSuccess={handleImageUploadSuccess}
        selectedProduct={selectedProduct}
        isBulk={false}
        type={"variant"}
      />
    </div>
  );
};

export default ProductDetail;
